
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    SECTION_TEMPLATE_DETAILS,
    fetchSectionTemplateSuccess,
    fetchSectionTemplateError,
    SECTION_TEMPLATE_ID,
    downloadSectionTemplateSuccess,
    downloadSectionTemplateFailure,
} from './action';
import { REPORT } from '../../../config';
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
/*const httpHeaders = {
    'Content-Type': 'multipart/form-data',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
};*/

export function* sectionTemplateDetails(action) {
    let requestUrl = `${REPORT}/section/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(fetchSectionTemplateSuccess(createResult));
    } catch (err) {
        yield put(fetchSectionTemplateError(err))
    }
}
export function* fetchSectionTemplateDetails() {
    yield takeLatest(SECTION_TEMPLATE_DETAILS, sectionTemplateDetails);
}

export function* getSectionTemplateFileUrl(action) {
    let requestUrl = `${REPORT}/section/url/${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS });
        yield put(downloadSectionTemplateSuccess(createResult.data));
    } catch (err) {
        yield put(downloadSectionTemplateFailure(err))
    }
}
export function* getSectionTemplateDownloadURL() {
    yield takeLatest(SECTION_TEMPLATE_ID, getSectionTemplateFileUrl);
}



